import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';

const maxAge = 60 * 60 * 24 * 90;

const checkValidation = (value) => !value ?? value === '';

const useSaveTrackingParamters = () => {
  const [cookies, setCookie] = useCookies();
  const location = useLocation();

  useEffect(() => {
    setCookieIfNotSet('first_visit_date', new Date().toISOString());
    setCookieIfNotSet('first_landing_page', location?.pathname);
    setCookieIfNotSet('first_touch_paramaters', window.location.href);
  }, []);

  useEffect(() => {
    setCookie('last_touch_paramaters', window.location.href, { maxAge });
  }, [location]);

  const setCookieIfNotSet = (cookieName, value) => {
    if (checkValidation(cookies[cookieName])) {
      setCookie(cookieName, value, { maxAge });
    }
  };

  return null;
};

export default useSaveTrackingParamters;
